import { styled, StyledText } from '@raskrask-dk/rr-components'

export const SpecialCareText = styled('div', {
    display: 'grid',
    gap: 16,

    [`& ${StyledText}`]: {
        whiteSpace: 'pre-line',
    },
})
